<template>
  <ListComponent title="Lease Driver Bonus" :totalCount="totalItems">
    <template #list>
      <v-row class="ma-0">
        <v-col cols="4" class="px-0 pt-0 pb-2">
          <v-text-field
            label="Search"
            outlined
            dense
            append-icon="mdi-magnify"
            clearable
            hide-details="auto"
            v-model="filters.search"
            @input="searchBranch"
          ></v-text-field>
        </v-col>

        <v-col
          v-if="totalItems > 0"
          cols="8"
          class="px-0 pt-0 pb-2 d-flex justify-end"
        >
          <Pagination
            :pageNo="pageNo"
            :totalItems="totalItems"
            :pageSize="itemsPerPage"
            @itemsPerPageChange="itemsPerPageChanged"
            @prevPage="prevPage"
            @nextPage="nextPage"
          />
        </v-col>

        <v-col cols="12" class="pa-0">
          <AgGridVue
            style="width: 100%; height: calc(100vh - 172px)"
            class="ag-theme-alpine"
            id="myGrid"
            :columnDefs="headers"
            :context="context"
            @grid-ready="onGridReady"
            :defaultColDef="defaultColDef"
            :grid-options="gridOptions"
            :suppressDragLeaveHidesColumns="true"
            :rowData="allUploadedExcelList"
          ></AgGridVue>
        </v-col>
      </v-row>
    </template>

    <template #dialogs>
      <BulkUpload
        v-model="driverBonusBulkUploadDialog"
        :uploadTo="uploadType"
        @refreshList="itemsPerPageChanged(20)"
      />
      <LeaseDriverBonusDialog
        v-model="showLeaseDriverDialog"
        :leaseDriverUploadId="leaseDriveExcelId"
        @refreshList="
          getLeaseDriverExcelList();
        "
      />
    </template>

    <template #actions>
      <v-btn
        class="ml-3"
        @click="openDriverBulkUpload('driver_bonus')"
        color="primary"
        depressed
      >
        <v-icon>mdi-plus</v-icon>
        <span>Bulk Upload</span>
      </v-btn>
    </template>
  </ListComponent>
</template>

<script>
import ListComponent from "@/components/General/ListComponent.vue";
import { AgGridVue } from "ag-grid-vue";
import Pagination from "@/components/General/Pagination.vue";
import LeaseDriverExcelButton from "@/components/AgGridComponents/LeaseDriverExcelButton.vue";
import CustomHeader from "@/components/AgGridComponents/General/CustomHeader.vue";
import BulkUpload from "@/components/General/BulkUpload.vue";
import LeaseDriverBonusDialog from "@/components/ModuleBased/dialogForms/LeaseDriverBonusDialog.vue";
import {
  isAuthenticated,
  hasRouteAccess,
  getPermissions,
} from "@/utils/functions";

export default {
  components: {
    ListComponent,
    agColumnHeader: CustomHeader,
    AgGridVue,
    Pagination,
    LeaseDriverBonusDialog,
    BulkUpload,
    LeaseDriverExcelButton,
  },

  data() {
    return {
      sorting: {},
      headers: [
        {
          headerName: "Reference No",
          field: "reference_no",
          sortable: true,
        },
        {
          headerName: "Created By",
          field: "created_by",
          sortable: true,
        },
        {
          headerName: "Created On",
          field: "created",
          sortable: true,
        },
        {
          headerName: "Actions",
          field: "actions",
          cellRendererFramework: "LeaseDriverExcelButton",
          pinned: "right",
          width: 90,
        },
      ],

      allUploadedExcelList: [],

      // pagination vars
      pageNo: 1,
      itemsPerPage: 20,
      totalItems: 0,
      filters: {},

      // ag-grid vars
      gridApi: null,
      gridColumnApi: null,
      defaultColDef: {
        resizable: true,
      },
      gridOptions: {
        onGridSizeChanged: () => {
          this.gridOptions.api.sizeColumnsToFit();
        },
        suppressRowClickSelection: true,
        suppressDragLeaveHidesColumns: true,
        enableCellTextSelection: true,
        tooltipShowDelay: 0,
        rowHeight: 35,
      },

      permissions: null,

      // bulk create
      leaseDriveExcelId: null,
      showLeaseDriverDialog: false,
      uploadType: "driver_bonus",
      driverBonusBulkUploadDialog: false,
    };
  },

  computed: {
    context() {
      return { parentComponent: this };
    },
    currentProfile() {
      if (JSON.parse(localStorage.getItem("userProfile"))) {
        return JSON.parse(localStorage.getItem("userProfile"));
      } else {
        return null;
      }
    },
    offset() {
      return this.itemsPerPage * (this.pageNo - 1);
    },
  },

  methods: {
    applyGridSort(key, type) {
      if (this.filters && !this.filters.ordering) {
        this.filters.ordering = [];
      }

      if (type == null) {
        delete this.sorting[key];
        this.filters.ordering.splice(
          this.filters.ordering.indexOf(`-${key}`),
          1
        );
      } else if (type == "asc") {
        this.filters.ordering.push(key);
      } else if (type == "desc") {
        this.filters.ordering.splice(
          this.filters.ordering.indexOf(key),
          1,
          `-${key}`
        );
      }
      if (this.filters.ordering.length == 0) {
        delete this.filters.ordering;
      }
      this.itemsPerPageChanged(20);
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
    searchBranch() {
      this.pageNo = 1;
      this.getLeaseDriverExcelList();
    },
    itemsPerPageChanged(e) {
      this.pageNo = 1;
      this.itemsPerPage = e;
      this.getLeaseDriverExcelList();
    },
    prevPage() {
      this.pageNo--;
      this.getLeaseDriverExcelList();
    },
    nextPage() {
      this.pageNo++;
      this.getLeaseDriverExcelList();
    },
    openDriverBulkUpload(type) {
      this.uploadType = type;
      this.driverBonusBulkUploadDialog = true;
    },

    viewLeaseDriverBonusList(id) {
      this.showLeaseDriverDialog = true
      this.leaseDriveExcelId = id
    },

    getLeaseDriverExcelList(params = {}) {
      this.$bus.$emit("showLoader", true);
      params = {
        offset: this.offset,
        limit: this.itemsPerPage,
        ...params,
        ...this.filters,
      };
      if ("ordering" in params && params.ordering.length > 0) {
        params = { ...params, ordering: params.ordering.join(",") };
      }
      this.$api.leaseDriverBonus
        .getleaseDriverBonusExceleList(params)
        .then((res) => {
          this.allUploadedExcelList = res.data;
          this.totalItems = res.count;
          this.$bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          this.$bus.$emit("showLoader", false);
        });
    },
  },
  beforeMount() {
    if (!isAuthenticated()) {
      this.$router.push("/");
    } else if (!hasRouteAccess(this.$route)) {
      this.$router.push(`/${localStorage.getItem("user_type").toLowerCase()}`);
    } else {
      const permissions = getPermissions("configuration");
      if (!permissions || !permissions.view) {
        this.$bus.$emit("showToastMessage", {
          message: "You don't have access to this page",
          color: "error",
        });
        this.$router.push(
          `/app/${
            localStorage.getItem("user_type")
              ? localStorage.getItem("user_type").toLowerCase()
              : "error"
          }`
        );
      } else {
        this.permissions = { ...permissions };
        this.getLeaseDriverExcelList();
      }
    }
  },
};
</script>
